<template>
  <footer>
    <div class="bg-footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-md-9">
            <h2>Como podemos te ajudar?</h2>
            <p>Se você é PCD ou trabalha em uma empresa que valoriza a inclusão, vamos conversar!</p>
          </div>
          <div class="col-xs-12 col-md-3">
            <a href="#" class="btn-white-green">Entre em contato</a>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="col-4 p-0 center-box">
            <img src="../assets/img/logo-incluir-da-certo.png" alt="Logo Incluir da Certo" class="logo-footer">
          </div>
          <div class="col-8 p-0 center-box">
            <ul class="social-icons">
              <li>
                <a href=""><img src="../assets/img/icon-facebook.png" alt="Ícone do Facebook - Link externo para o Facebook da Incluir da Certo"></a>
              </li>
              <li>
                <a href=""><img src="../assets/img/icon-linkedin.png" alt="Ícone do LinkedIn - Link externo para o LinkedIn da Incluir da Certo"></a>
              </li>
              <li>
                <a href=""><img src="../assets/img/icon-instagram.png" alt="Ícone do Instagram - Link externo para o Instagram da Incluir da Certo"></a>
              </li>
              <li>
                <a href=""><img src="../assets/img/icon-youtube.png" alt="Ícone do Youtube - Link externo para o Youtube da Incluir da Certo"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Banner',
  data () {
    return {
      msg: 'Incluir da Certo'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~styles/_bootstrap-variables";
  @import "~styles/_mixin-buttons";
  @import "~styles/_main";
  @import "~styles/_footer";
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue